<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              핀 위치 통계
            </div>
          </section>
          <section class="section02" v-if="false">
            <div class="object01"></div>
            <div class="object02" v-show="userInfo.userRole !== 'ClubManager'">
              <div class="form">
                <div class="formSelect" ref="select01">
                  <!--<div class="formSelectList" @click="openSelect01">-->
                  <div class="formSelectList">
                    <input type="text" v-model="currentClubInfo.club_name" placeholder="골프클럽을 선택하세요." readonly />
                  </div>
                  <div class="formSelectPopup typeSearch select01">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" placeholder="골프클럽을 선택하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                  <label>
                                    <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                                  취소
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                                  확인
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <div class="object01"></div>
            <!-- 툴팁 활성(Class) : tooltipActive -->
            <div class="object02" :class="tooltipActive ? 'tooltipActive' : ''">
              <div class="form">
                <ul class="month">
                  <!-- 활성(Class) : active -->
                  <li @click="setSearchPeriod(1)">
                    1개월
                  </li>
                  <li @click="setSearchPeriod(3)">
                    3개월
                  </li>
                  <li @click="setSearchPeriod(6)">
                    6개월
                  </li>
                </ul>
                <div class="formCalendar">
                  <div class="formCalendarList">
                    <date-picker
                      v-model="dateRange"
                      type="date" range
                      :format="'YYYY-MM-DD'"
                      :clearable="false"
                      @change="updateValues"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(1, emit)">
                            1개월
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(3, emit)">
                            3개월
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(6, emit)">
                            6개월
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>
                <div class="item" @click="openTooltip" ref="tooltip">
                  <div class="tooltip">
                    검색한 기간의 통합 통계입니다.
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <div class="object0101">
                <div class="course">
                  <div class="title">
                    코스
                  </div>
                  <div class="formSelect" @click="openSelect02" ref="select02">
                    <div class="formSelectList">
                      <input type="text" v-model="currentCourseInfo.name" placeholder="코스" readonly />
                    </div>
                    <div class="formSelectPopup select02">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" value="LUNAR" placeholder="코스" />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                                    <label>
                                      <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect02()"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{courseInfo.name}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hole">
                  <div class="title">
                    홀
                  </div>
                  <div class="formSelect">
                    <div class="formSelectList" @click="openSelect03" ref="select03">
                      <input type="text" v-model="currentHoleNo" placeholder="홀" readonly />
                    </div>
                    <div class="formSelectPopup select03">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="유형을 선택하세요." />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                                    <label>
                                      <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect03()"/>
                                      <input type="checkbox"  />
                                      <i></i>
                                      <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="object0102">
                <div class="content" :class="{mobileDoubleContent: mobileFlag && pinStatisticsData.pinListR && pinStatisticsData.pinListR.length}">
                  <div class="graph" style="line-height: 0; text-align: center; font-size: 0;">
                    <div class="object"></div>
                    <div class="pointZone">
                      <!-- 위치값(Style) : x, y 좌표 -->
                      <div class="pointZoneLeft">
                        <div v-for="(pointY, i) in pointListL" :key="i" class="pointGridRow" :style="gridRowStyle()">
                          <div v-for="(pointX, j) in pointY" :key="i+j" class="pointGridItem" :style="gridItemStyle(pointX, 'lg')">
                            {{ pointX === 0 ? '' : (pointX * 100 / pinStatisticsData.pinListL.length).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                      <div v-if="pinStatisticsData.imageInfo.rg.imageFound && pinStatisticsData.pinListR && pinStatisticsData.pinListR.length" class="pointZoneRight">
                        <div v-for="(pointY, i) in pointListR" :key="i" class="pointGridRow" :style="gridRowStyle()">
                          <div v-for="(pointX, j) in pointY" :key="i+j" class="pointGridItem" :style="gridItemStyle(pointX, 'rg')">
                            {{ pointX === 0 ? '' : (pointX * 100 / pinStatisticsData.pinListR.length).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="greenImage" :style="{'width': this.mapAreaSize+'px', 'background-image': 'url(' + pinStatisticsData.imageInfo.lg.imageUrl + ')'}">
                    </div>
                    <div v-if="pinStatisticsData.imageInfo.rg.imageFound && pinStatisticsData.pinListR && pinStatisticsData.pinListR.length" class="greenImage" :style="{'width': this.mapAreaSize+'px', 'background-image': 'url(' + pinStatisticsData.imageInfo.rg.imageUrl + ')'}">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="골프클럽을 선택하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" value="LUNAR" placeholder="코스" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                      <label>
                        <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect02()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{courseInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="유형을 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                      <label>
                        <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect03()"/>
                        <input type="checkbox"  />
                        <i></i>
                        <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import {clubInfoService, commonService, caService, userService} from '../../router'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'

export default {
  name: 'CR101',
  data () {
    return {
      pinStatisticsData: {
        imageInfo: {
          lg: {},
          rg: {}
        },
        pinListL: [],
        pinListR: []
      },
      currentHoleInfo: {
        aplId: '',
        battery: '',
        grsel: 'L',
        hlidx: '',
        isActive: true,
        lat: '',
        lon: '',
        lowBattery: false,
        nhole: '',
        temp: null,
        updateAt: ''
      },
      dateRange: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
      sDate: '',
      eDate: '',
      mapAreaSize: 0,
      selectCourseId: '',
      selectHlidx: 0,
      currentHlidx: 0,
      pointListL: [],
      pointListR: []
    }
  },
  created: function () {
    let fromDate = new Date().setDate(new Date().getDate() - 7)
    let toDate = new Date()
    this.sDate = moment(fromDate).format('YYYY-MM-DD')
    this.eDate = moment(toDate).format('YYYY-MM-DD')

    userService.getAll().then(response => {
      this.userInfo = response.data
      clubInfoService.getClubInfoList('active').then(response => {
        this.clubInfoList = response.data.clubInfoList
        this.selectClubInfoList = response.data.clubInfoList
        if (this.userInfo.userRole === 'ClubManager') {
          this.currentClubCode = this.userInfo.ccode
        } else {
          if (this.$route.query.ccode === undefined) {
            this.currentClubCode = this.clubInfoList[0].ccode
          } else {
            this.currentClubCode = this.$route.query.ccode
          }
          this.setClubInfo()
        }
        this.selectCcode = this.currentClubCode
        commonService.getCourseListByCcode(this.currentClubCode).then(response => {
          this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
          for (let i in this.courseList) {
            let holeCnt = this.courseList[i].endIdx - this.courseList[i].startIdx
            if (this.maxHoleCnt < holeCnt) this.maxHoleCnt = holeCnt
          }
          if (this.courseList[0] !== undefined) {
            this.currentCourseInfo = this.courseList[0]
            this.selectCourseId = this.currentCourseInfo.courseId
          }
          this.setData()
        }).catch(error => {
          console.log('getCourseListByCcode.err.===>', error)
        })
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    })
  },
  mounted: function () {
    if (this.mobileFlag) {
      if (window.innerWidth > 1279) {
        this.mobileFlag = false
      }
    } else {
      if (window.innerWidth < 1280) {
        this.mobileFlag = true
      }
    }
    if (document.querySelector('.object0102 .content') === null) return
    this.mapAreaSize = document.querySelector('.object0102 .content').clientHeight
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker
  },
  methods: {
    setData: function () {
      caService.getPinStatistics(this.currentClubCode, this.currentHlidx, this.sDate, this.eDate).then(response => {
        this.pinStatisticsData = response.data.pinStatisticsData
        this.setPointList()
      }).catch(error => {
        console.log('getPinStatistics.err.===>', error)
      })
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    confirmSelect01: function () {
      this.currentClubCode = this.selectCcode
      this.setClubInfo()
      this.selectHlidx = 0
      this.currentHlidx = this.selectHlidx
      commonService.getCourseListByCcode(this.currentClubCode).then(response => {
        this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
        this.currentCourseInfo = this.courseList[0]
        this.selectCourseId = this.currentCourseInfo.courseId
        this.setData()
      }).catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
      this.closeSelectAll()
    },
    confirmSelect02: function () {
      this.currentCourseInfo = this.courseList.find(it => it.courseId === this.selectCourseId)
      this.selectHlidx = this.currentCourseInfo.startIdx
      this.confirmSelect03()
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentHlidx = this.selectHlidx
      this.setData()
      this.closeSelectAll()
    },
    setPointList: function (gridX = 12, gridY = 12) {
      if (this.mobileFlag) {
        gridX = 8
        gridY = 8
      }
      this.pointListL = new Array(gridY).fill(new Array(gridX).fill(0))
      this.pointListL = JSON.parse(JSON.stringify(this.pointListL))
      this.pointListR = JSON.parse(JSON.stringify(this.pointListL))
      for (let pinIdx in this.pinStatisticsData.pinListL) {
        let pinInfo = this.pinStatisticsData.pinListL[pinIdx]
        let pinXY = this.pos2Pix(this.pinStatisticsData.imageInfo.lg.points, pinInfo.lat, pinInfo.lon, this.mapAreaSize, this.mapAreaSize)
        for (let i in this.pointListL) {
          if (Math.floor((this.mapAreaSize * (Number(i) + 1)) / gridY) < pinXY.y) continue
          for (let j in this.pointListL[i]) {
            if (Math.floor((this.mapAreaSize * (Number(j) + 1)) / gridX) < pinXY.x) continue
            this.pointListL[i][j]++
            break
          }
          break
        }
      }
      if (!this.pinStatisticsData.pinListR || !this.pinStatisticsData.pinListR.length) return
      for (let pinIdx in this.pinStatisticsData.pinListR) {
        let pinInfo = this.pinStatisticsData.pinListR[pinIdx]
        let pinXY = this.pos2Pix(this.pinStatisticsData.imageInfo.rg.points, pinInfo.lat, pinInfo.lon, this.mapAreaSize, this.mapAreaSize)
        for (let i in this.pointListR) {
          if (Math.floor((this.mapAreaSize * (Number(i) + 1)) / gridY) < pinXY.y) continue
          for (let j in this.pointListR[i]) {
            if (Math.floor((this.mapAreaSize * (Number(j) + 1)) / gridX) < pinXY.x) continue
            this.pointListR[i][j]++
            break
          }
          break
        }
      }
    },
    updateValues: function (dateRange) {
      this.sDate = moment(dateRange[0]).format('YYYY-MM-DD')
      this.eDate = moment(dateRange[1]).format('YYYY-MM-DD')
      this.setData()
    },
    setSearchPeriod: function (months, emit) {
      let fromDate = new Date(new Date().setMonth(new Date().getMonth() - months))
      let toDate = new Date()
      this.sDate = moment(fromDate).format('YYYY-MM-DD')
      this.eDate = moment(toDate).format('YYYY-MM-DD')
      this.dateRange[0] = fromDate
      this.dateRange[1] = toDate
      this.setData()
      emit(this.dateRange)
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.mapAreaSize = document.querySelector('.object0102 .content').clientHeight
          this.setPointList()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.mapAreaSize = document.querySelector('.object0102 .content').clientHeight
          this.setPointList()
        }
      }
    },
    gridRowStyle: function () {
      return {
        height: (this.mapAreaSize / this.pointListL.length) + 'px',
        lineHeight: (this.mapAreaSize / this.pointListL.length) + 'px'
      }
    },
    gridItemStyle: function (value, grsel) {
      let bgClr = ''
      value = Number((value * 100 / this.pinStatisticsData[grsel === 'lg' ? 'pinListL' : 'pinListR'].length).toFixed(2))
      if (value > 20) {
        bgClr = '#d0202e'
      } else if (value > 5) {
        bgClr = 'rgba(0,0,0,.65)'
      } else if (value > 0) {
        bgClr = 'rgba(0,0,0,.4)'
      }
      return {
        width: (this.mapAreaSize / this.pointListL[0].length) + 'px',
        backgroundColor: bgClr
      }
    }
  },
  computed: {
    currentHoleNo: function () {
      return 'Hole ' + this.viewHoleNo(this.currentHlidx)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ca/CR101.vue